import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useAuthEmail } from '@/components/auth/shared/auth-email';
import { ForgotPasswordForm } from '@/components/auth/forgot-password/forgot-password-form';
import { AuthCard } from '@/components/auth/shell/auth-card';
import { AuthSplitShell } from '@/components/auth/shell/auth-split-shell';
import { AuthTopLink } from '@/components/auth/shell/auth-top-link';
import { AUTH_HEADLINE } from '@/components/ui/typography';
import { ROUTES } from '@/constants/routes';
import { loadNamespaces } from '@/lib/i18n/i18n';

export const Route = createFileRoute('/_public/forgot-password')({
  loader: () => loadNamespaces('auth'),
  staticData: { title: 'route.forgot_password.title' },
  component: ForgotPasswordPage,
});

const TopBar = () => {
  const { t } = useTranslation('auth');

  return (
    <AuthTopLink to={ROUTES.LOGIN}>{t('forgot_password.top_back')}</AuthTopLink>
  );
};

function ForgotPasswordPage() {
  const { t } = useTranslation('auth');
  const email = useAuthEmail();

  return (
    <AuthSplitShell topBar={<TopBar />}>
      <h1 className={AUTH_HEADLINE}>{t('forgot_password.heading')}</h1>

      <AuthCard>
        <ForgotPasswordForm initialEmail={email} />
        <p className="text-fg-4 text-fs-11 mt-4 text-center">
          {t('forgot_password.provider_note')}
        </p>
      </AuthCard>
    </AuthSplitShell>
  );
}
